import type { CSSProperties } from "react";
import {
  AvailabilityOverviewUnavailableReason,
  ShowingStatus
} from "api/scheduling/types";
import { showingStatusConfig } from "views/showings/constants";

export const SHOWING_AVAILABILITY_TAB_LABEL = "Showing availability";

// Fallback used only before the first response arrives — the real band comes
// per day from `day_bands` and may be any span, including empty.
export const BAND_START_HOUR = 9;
export const BAND_END_HOUR = 23;

// Minimum width of one hour column — short bands stretch to fill the card,
// only wider ones scroll.
export const HOUR_COL_PX = 132;

// Height (px) of one team-member lane on the vertical axis.
export const MEMBER_ROW_PX = 64;

// Fixed width (px) of the sticky member-name column on the left.
export const MEMBER_NAME_COL_PX = 164;

// Solid fill for available regions (design: plain green, no border or label).
export const AVAILABLE_FILL_CLASS = "bg-success-100";

// Legend swatch, read off the default card treatment so the two cannot drift.
export const SHOWING_FILL_CLASS =
  showingStatusConfig[ShowingStatus.Confirmed].bgClass;

// Diagonal hatch for unavailable regions, per the Figma spec (135° lines in
// #1C1D22 at 5% opacity). Inline style because Tailwind has no hatch token.
export const UNAVAILABLE_HATCH_STYLE: CSSProperties = {
  backgroundImage:
    "repeating-linear-gradient(135deg, rgba(28, 29, 34, 0.05) 0px, rgba(28, 29, 34, 0.05) 1px, transparent 1px, transparent 7px)"
};

// Tooltip subtitle per unavailable-reason category. "outside_hours" is
// templated with the member's name in the component. Unknown categories fall
// back to no subtitle (the "Unavailable <range>" title alone).
export const UNAVAILABLE_REASON_COPY: Record<
  AvailabilityOverviewUnavailableReason,
  string
> = {
  outside_hours: "Outside {name} daily hours",
  conflict: "Calendar conflict",
  buffer: "Buffer time around another commitment"
};
